'use es6';

import { combineReducers } from 'redux';
import SeamlessImmutable from 'seamless-immutable';
import { DESIGN_COMPONENTS_CODE_ACCORDION_UPDATE } from 'DesignData/actions/ActionTypes';

function accordionItems(state = SeamlessImmutable({}), action) {
  switch (action.type) {
    case DESIGN_COMPONENTS_CODE_ACCORDION_UPDATE:
      {
        return SeamlessImmutable.merge(state, action.data.options, {
          deep: true
        });
      }

    default:
      return state;
  }
}

function accordionsById(state = SeamlessImmutable({}), action) {
  switch (action.type) {
    case DESIGN_COMPONENTS_CODE_ACCORDION_UPDATE:
      {
        const {
          id
        } = action;
        if (!id) return state;
        return SeamlessImmutable.set(state, id, accordionItems(state[id], action));
      }

    default:
      return state;
  }
}

export default combineReducers({
  accordionsById
});